/** Jezici sa slovenskom množinom (1 obrok, 2 obroka, 5 obroka, 21 obrok). */
const SLAVIC_LOCALES = ["sr", "rs", "sr-lat", "rs-lat", "hr", "bs", "ba", "mk", "si", "ru"];

/**
 * @param {number} count
 * @param {string} locale
 * @returns {"one"|"few"|"many"}
 */
export const pluralForm = (count, locale) => {
  const n = Math.abs(count);
  if (!SLAVIC_LOCALES.includes(locale)) {
    return n === 1 ? "one" : "many";
  }
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return "one";
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return "few";
  }
  return "many";
};

export default {
  methods: {
    /**
     * Prevod sa množinom: ključ ima podključeve one / few / many i parametar {n}.
     * @param {string} key
     * @param {number} count
     * @returns {string}
     */
    pluralT(key, count) {
      return this.$t(`${key}.${pluralForm(count, this.$i18n.locale)}`, { n: count });
    },
  },
};
